import { ShieldCheck, Lock, FileCheck2, Scale, Award, MapPin } from "lucide-react";

const BADGES = [
  { Icon: ShieldCheck, title: "GDPR-conform", text: "Documenten 30 dagen bewaard, daarna automatisch verwijderd." },
  { Icon: Lock, title: "Versleutelde uploads", text: "Alle bestanden via SSL en encrypted-at-rest." },
  { Icon: FileCheck2, title: "Juridische expertise", text: "Geijkt op Belgische & Nederlandse wetgeving." },
  { Icon: Scale, title: "Onafhankelijk", text: "Geen banden met aannemers, banken of verzekeraars." },
  { Icon: Award, title: "Geen abonnement", text: "Je betaalt per analyse. Geen verborgen kosten." },
  { Icon: MapPin, title: "Voor BE & NL", text: "Specifiek voor Belgische en Nederlandse particulieren." },
];

export default function TrustBadges() {
  return (
    <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-6" data-testid="trust-badges">
      {BADGES.map(({ Icon, title, text }) => (
        <div
          key={title}
          className="rounded-2xl bg-white border border-border p-6"
        >
          <div className="h-11 w-11 rounded-xl bg-slate-100 flex items-center justify-center text-ink">
            <Icon className="h-5 w-5" />
          </div>
          <h4 className="font-display font-semibold text-ink mt-4">{title}</h4>
          <p className="text-sm text-ink-soft mt-1 leading-relaxed">{text}</p>
        </div>
      ))}
    </div>
  );
}
